import actionTypes from './actions/actiontypes';

const {
  REQUEST_ROOM_RECORDINGS,
  RECEIVE_ROOM_RECORDINGS,
  SERVER_ERROR_OCURED,
  CLEAR_ERRORS
} = actionTypes;

const roomRecordingsReducer = (state = {
  isFetchingList: false,
  roomRecordings: [],
  hasServerError: false,
  errors: {},
  success: false,
  msg: ''
}, action) => {
  switch (action.type) {

    case REQUEST_ROOM_RECORDINGS:
      return Object.assign({}, state, {
        isFetchingList: true,
        hasServerError: false,
        errors: {},
        success: false,
        msg: ''
      });
    case CLEAR_ERRORS:
        return Object.assign({}, state, {
          hasServerError: false,
          errors: {},
          success: false,
          msg: ''
        });
    case RECEIVE_ROOM_RECORDINGS:
      return Object.assign({}, state, {
        isFetchingList: false,
        roomRecordings: action.roomRecordings
      });
    case SERVER_ERROR_OCURED:
      return Object.assign({}, state, {
        hasServerError: true,
        errors: action.errors,
        success: false
      });
    default:
      return state;
  }
};

export default roomRecordingsReducer;


// WEBPACK FOOTER //
// src/routes/RoomRecordings/reducer.js